import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/node/frontend/src/app/persistantProvider.tsx");
